import { Component, Input,NgModule } from '@angular/core';
import { Base64Pipe } from "../../commons/ImagePipe";

@Component({
  selector: 'app-prikaz-slike',
  standalone: true,
  imports: [Base64Pipe],
  templateUrl: './prikaz-slike.component.html',
  styleUrl: './prikaz-slike.component.css'
})
export class PrikazSlikeComponent {
  @Input() image: "";  

}
